(function() {

  /* ── Injection CSS modal ── */
  var style = document.createElement('style');
  style.textContent = '#sqoverlay{display:none;position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(10,0,5,0.6);z-index:999999;align-items:center;justify-content:center;padding:20px}#sqoverlay.open{display:flex!important}#sqmodal{background:#fff;border-radius:6px;padding:28px 24px 22px;max-width:540px;width:90%;position:relative;box-shadow:0 20px 60px rgba(82,13,35,0.18);margin:0;max-height:85vh;overflow-y:auto;font-family:Saira,Arial,sans-serif}#sqmodal .sqclose{position:absolute;top:14px;right:16px;background:none;border:none;font-size:22px;color:#999;cursor:pointer;line-height:1}#sqmodal .sqclose:hover{color:#520d23}#sqmodal .sqheader{display:flex;align-items:center;gap:16px;margin-bottom:24px;padding-bottom:20px;border-bottom:2px solid #520d23}#sqmodal .sqlogo{height:52px;width:auto}#sqmodal .sqtitle{font-size:18px;font-weight:700;color:#520d23}#sqmodal .sqsubtitle{font-size:12px;color:#888;margin-top:2px}#sqmodal .sqgrid{display:grid;grid-template-columns:1fr 1fr;gap:14px;margin-bottom:20px}#sqmodal .sqfield{display:flex;flex-direction:column;gap:5px}#sqmodal .sqfull{grid-column:1/-1}#sqmodal .sqlabel{font-size:11px;font-weight:700;color:#444;text-transform:uppercase;letter-spacing:0.4px}#sqmodal .sqreq{color:#520d23}#sqmodal .sqinput{padding:9px 11px;border:1px solid #ddd;border-radius:3px;font-size:13px;font-family:Saira,Arial,sans-serif;color:#1a1a1a;transition:border-color 0.15s;width:100%;box-sizing:border-box}#sqmodal .sqinput:focus{outline:none;border-color:#520d23}#sqmodal textarea.sqinput{resize:vertical}#sqmodal .sqerror{color:#c0392b;font-size:12px;margin-bottom:12px;display:none}#sqmodal .sqgenerate{display:flex;align-items:center;justify-content:center;gap:9px;width:100%;padding:14px 20px;background:#520d23;color:#fff;border:none;border-radius:3px;font-family:Saira,Arial,sans-serif;font-size:14px;font-weight:700;cursor:pointer;transition:background 0.18s}#sqmodal .sqgenerate:hover{background:#3a091a}#sqmodal .sqgenerate:disabled{background:#aaa;cursor:default}#sqmodal .sqlegal{margin-top:14px;font-size:11px;color:#aaa;text-align:center;line-height:1.6}#sqmodal .sqlegal a{color:#520d23}@media(max-width:480px){#sqmodal .sqgrid{grid-template-columns:1fr}#sqmodal{padding:24px 18px 20px}}';
  document.head.appendChild(style);

  var isEN = (document.documentElement.lang || 'fr').indexOf('en') === 0;

  var T = isEN ? {
    btn:          "Download my quote",
    title:        "Quote request",
    subtitle:     "Your details to personalize the document",
    company:      "Company",
    name:         "First & Last name",
    email:        "Email",
    phone:        "Phone",
    address:      "Delivery address",
    note:         "Comments",
    ph_company:   "Your company name",
    ph_name:      "Your full name",
    ph_email:     "your@email.com",
    ph_phone:     "+1 000 000 0000",
    ph_address:   "Address, zip code, city, country",
    ph_note:      "Desired lead time, special conditions...",
    generate:     "Generate and download PDF quote",
    legal:        "This quote is valid for 30 days and does not constitute a firm order.",
    confirm:      "To confirm your order:",
    generating:   "Generating...",
    success:      "Quote downloaded!",
    success_msg:  "Your quote has been generated. Our team will contact you within 2-3 business days",
    close:        "Close",
    err_fields:   "Please fill in your name and email.",
    err_email:    "Invalid email address.",
    err_cart:     "Your cart is empty.",
    err_gen:      "Error generating quote. Please try again.",
    livraison:    "DELIVERY TO:",
    conditions:   "QUOTE CONDITIONS:",
    cond_text:    "This quote is valid for 30 days from the date of issue. Prices are shown excluding tax. Any order placed following this quote implies acceptance of our general terms and conditions of sale.",
    clause:       "RETENTION OF TITLE CLAUSE:",
    clause_text:  "In accordance with law 80-335 of 12 May 1980, we remain the owner of the goods until full payment has been received. Acceptance of delivery implies acceptance of this clause.",
    valid_days:   "Quote valid 30 days /",
    note_label:   "NOTE:"
  } : {
    btn:          "Télécharger mon devis",
    title:        "Demande de devis",
    subtitle:     "Vos coordonnées pour personnaliser le document",
    company:      "Société",
    name:         "Nom & Prenom",
    email:        "Email",
    phone:        "Téléphone",
    address:      "Adresse de livraison",
    note:         "Remarques",
    ph_company:   "Nom de votre société",
    ph_name:      "Votre nom complet",
    ph_email:     "votre@email.com",
    ph_phone:     "+33 6 00 00 00 00",
    ph_address:   "Adresse, code postal, ville, pays",
    ph_note:      "Délai souhaite, conditions particulières...",
    generate:     "Générer et télécharger le devis PDF",
    legal:        "Ce devis est valable 30 jours. Il ne constitue pas une commande ferme.",
    confirm:      "Pour confirmer votre commande :",
    generating:   "Génération en cours...",
    success:      "Devis téléchargé !",
    success_msg:  "Votre devis a bien ete généré. Notre équipe vous recontactera sous 1-2 jours ouvrés",
    close:        "Fermer",
    err_fields:   "Merci de renseigner votre nom et email.",
    err_email:    "Email invalide.",
    err_cart:     "Votre panier est vide.",
    err_gen:      "Erreur lors de la génération. Veuillez réessayer.",
    livraison:    "LIVRAISON A :",
    conditions:   "CONDITIONS DU DEVIS :",
    cond_text:    "Ce devis est valable 30 jours a compter de sa date d émission. Les prix sont indiques hors taxes. Toute commande passée suite a ce devis implique l acceptation de nos conditions générales de vente.",
    clause:       "CLAUSE DE RESERVE DE PROPRIETE :",
    clause_text:  "Suivant la loi 80-335 du 12 mai 1980, nous restons propriétaires des marchandises tant qu elles n ont pas été intégralement payées par l acheteur. L acceptation de la livraison équivaut a l acceptation de cette clause.",
    valid_days:   "Devis valable 30 jours /",
    note_label:   "NOTE :"
  };

  function fmt(cents) {
    var n = (cents / 100).toFixed(2), p = n.split('.');
    return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0') + ',' + p[1] + '\u00a0\u20ac';
  }
  function today() { return new Date().toLocaleDateString('fr-FR'); }
  function qNum() { return 'DV-' + Date.now().toString().slice(-8); }
  function rgb(h) { var r = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(h); return r ? [parseInt(r[1],16), parseInt(r[2],16), parseInt(r[3],16)] : [0,0,0]; }

  function loadPDF() {
    return new Promise(function(resolve, reject) {
      if (window.jspdf && window.jspdf.jsPDF) { resolve(window.jspdf.jsPDF); return; }
      var s = document.createElement('script');
      s.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
      s.onload = function() { if (window.jspdf && window.jspdf.jsPDF) resolve(window.jspdf.jsPDF); else reject(new Error('KO')); };
      s.onerror = function() { reject(new Error('Load failed')); };
      document.head.appendChild(s);
    });
  }

  function loadImg(url) {
    return new Promise(function(resolve) {
      var img = new Image(); img.crossOrigin = 'anonymous';
      img.onload = function() {
        var cv = document.createElement('canvas');
        cv.width = img.naturalWidth || 200; cv.height = img.naturalHeight || 100;
        cv.getContext('2d').drawImage(img, 0, 0); resolve(cv.toDataURL('image/png'));
      };
      img.onerror = function() { resolve(null); };
      img.src = url + '?t=' + Date.now();
    });
  }

  function hline(doc, x1, y, x2, col, lw) { doc.setDrawColor(...(col||[204,204,204])); doc.setLineWidth(lw||0.25); doc.line(x1,y,x2,y); }
  function vline(doc, x, y1, y2, col, lw) { doc.setDrawColor(...(col||[204,204,204])); doc.setLineWidth(lw||0.25); doc.line(x,y1,x,y2); }
  function fillRect(doc, x, y, w, h, fill) { doc.setFillColor(...fill); doc.rect(x,y,w,h,'F'); }
  function strokeRect(doc, x, y, w, h, col) { doc.setDrawColor(...(col||[204,204,204])); doc.setLineWidth(0.25); doc.rect(x,y,w,h,'S'); }
  function txt(doc, t, x, y, opts) {
    opts = opts || {};
    if (opts.color) doc.setTextColor(...opts.color);
    if (opts.size) doc.setFontSize(opts.size);
    if (opts.bold !== undefined) doc.setFont('helvetica', opts.bold ? 'bold' : 'normal');
    doc.text(t, x, y, {align: opts.align || 'left', maxWidth: opts.maxWidth});
  }

  async function makePDF(client, cart) {
    var jsPDF = await loadPDF();
    var doc = new jsPDF({unit: 'mm', format: 'a4', orientation: 'portrait'});
    var W = 210, mL = 14, mR = 14, cW = W - mL - mR;
    var bord = rgb('#520d23');
    var border = [204,204,204], gray = [242,242,242], mut = [102,102,102], blk = [26,26,26], wht = [255,255,255];
    var num = qNum(), y = 12;

    var logoB64 = await loadImg('https://cdn.shopify.com/s/files/1/0692/0074/0660/files/Logo_detoure.png?v=1670432566');
    if (logoB64) {
      var ti = new Image(); ti.src = logoB64;
      var ratio = (ti.naturalWidth && ti.naturalHeight) ? ti.naturalWidth / ti.naturalHeight : 1;
      var lh = 22, lw = lh * ratio; if (lw > 36) { lw = 36; lh = lw / ratio; }
      doc.addImage(logoB64, 'PNG', mL, y, lw, lh);
    }

    var shopX = mL + 38;
    txt(doc, 'SEAT VENTILATION SAS', shopX, y+5, {bold:true, size:9, color:bord});
    doc.setFont('helvetica','normal').setFontSize(7.5).setTextColor(...blk);
    ['70, Impasse Jean Mermoz','Parc Technologique Delta Sud','09340 VERNIOLLE - FRANCE'].forEach(function(l,i) { doc.text(l, shopX, y+10+i*3.8); });
    [['Tel :', '+33 (0)5 61 69 84 43'],['Fax :', '+33 (0)5 61 67 86 03'],
     ['E-mail :', 'compta@seat-ventilation.com'],['URL :', 'www.seat-ventilation.com']
    ].forEach(function(r,i) {
      doc.setFont('helvetica','bold').setFontSize(7.5).text(r[0], shopX, y+24+i*3.8);
      doc.setFont('helvetica','normal').text(r[1], shopX+11, y+24+i*3.8);
    });

    var livX = mL + 108;
    vline(doc, livX-2, y, y+40, border);
    txt(doc, T.livraison, livX, y+4, {bold:true, size:7, color:mut});
    var livLines = [];
    if (client.company) livLines.push(client.company);
    livLines.push(client.name);
    if (client.address) { client.address.split(',').forEach(function(p) { var t = p.trim(); if (t) livLines.push(t); }); }
    if (client.phone) livLines.push(client.phone);
    livLines.forEach(function(l, i) {
      if (i === 0) { doc.setFont('helvetica','bold').setFontSize(8.5); } else { doc.setFont('helvetica','normal').setFontSize(7.5); }
      doc.setTextColor(...blk); doc.text(l, livX, y+9+i*4);
    });

    y += 42;
    hline(doc, mL, y, W-mR, bord, 0.7);
    y += 2;

    var metaH = 30, metaLW = cW * 0.62, metaRW = cW * 0.38;
    fillRect(doc, mL, y, metaLW, metaH, gray);
    strokeRect(doc, mL, y, metaLW, metaH, border);
    strokeRect(doc, mL+metaLW, y, metaRW, metaH, border);

    var topH = 11;
    hline(doc, mL, y+topH, mL+metaLW, border);
    var cells = [
      {lbl:'N DEVIS', val:num, w:24},
      {lbl:'N COMPTE TIERS', val:'-', w:24},
      {lbl:'DOC', val:'DV', w:12},
      {lbl:'DATE', val:today(), w:22},
    ];
    var cx2 = mL;
    cells.forEach(function(c) {
      vline(doc, cx2+c.w, y, y+topH, border);
      txt(doc, c.lbl, cx2+2, y+3.5, {bold:false, size:6, color:mut});
      txt(doc, c.val, cx2+2, y+8.5, {bold:true, size:8, color:bord});
      cx2 += c.w;
    });
    var devisW = metaLW - (24+24+12+22);
    txt(doc, 'DEVIS', mL+metaLW-devisW/2, y+7.5, {bold:true, size:10, color:bord, align:'center'});

    var refY = y + topH;
    hline(doc, mL, refY+5, mL+metaLW, border);
    txt(doc, 'Devis : ' + num, mL+2, refY+3.5, {bold:false, size:7, color:mut});

    var expY = refY + 5;
    var expCells = [
      {lbl:'MODE D EXPEDITION', val:'Standard', w:38},
      {lbl:'PORT', val:'DDP', w:14},
      {lbl:'EMBALL.', val:'FCO', w:16},
      {lbl:'COLIS', val:'-', w:14},
      {lbl:'POIDS BRUT', val:'-', w:16},
      {lbl:'POIDS NET', val:'-', w:0},
    ];
    var ex = mL;
    expCells.forEach(function(c, i) {
      if (i < expCells.length-1) vline(doc, ex+c.w, expY, y+metaH, border);
      txt(doc, c.lbl, ex+2, expY+3, {bold:false, size:6, color:mut});
      txt(doc, c.val, ex+2, expY+7.5, {bold:true, size:7.5, color:blk});
      ex += c.w;
    });

    var bx = mL+metaLW+2, by = y+2;
    if (client.company) {
      txt(doc, client.company, bx, by+2, {bold:true, size:8.5, color:bord});
      txt(doc, client.name, bx, by+7, {bold:false, size:7.5, color:blk});
      by += 10;
    } else {
      txt(doc, client.name, bx, by+2, {bold:true, size:8.5, color:bord});
      by += 7;
    }
    if (client.address) { client.address.split(',').forEach(function(p) { var t = p.trim(); if (t) { txt(doc, t, bx, by, {bold:false, size:7.5, color:blk}); by += 4; } }); }
    if (client.email) { txt(doc, client.email, bx, by+1, {bold:false, size:7.5, color:blk}); by += 4; }
    if (client.phone) { txt(doc, client.phone, bx, by+1, {bold:false, size:7.5, color:blk}); }

    y += metaH + 2;

    var thH = 8;
    fillRect(doc, mL, y, cW, thH, bord);
    doc.setFont('helvetica','bold').setFontSize(7).setTextColor(...wht);
    var tcols = [
      {lbl:'QTE', x:mL, w:12, a:'center'},
      {lbl:'LIBELLE', x:mL+12, w:76, a:'left'},
      {lbl:'PRIX NET HT', x:mL+88, w:24, a:'right'},
      {lbl:'MONTANT HT', x:mL+112, w:24, a:'right'},
      {lbl:'TVA', x:mL+136, w:14, a:'center'},
      {lbl:'TOTAL TTC', x:mL+150, w:cW-150, a:'right'},
    ];
    tcols.forEach(function(c, i) {
      var tx = c.a === 'right' ? c.x+c.w-2 : c.a === 'center' ? c.x+c.w/2 : c.x+2;
      doc.text(c.lbl, tx, y+5.5, {align: c.a});
      if (i < tcols.length-1) { doc.setDrawColor(255,255,255); doc.setLineWidth(0.2); doc.line(c.x+c.w, y, c.x+c.w, y+thH); }
    });
    y += thH;

    var totHT = 0, totTTC = 0;
    cart.items.forEach(function(item, idx) {
      var uTTC = item.price, uHT = Math.round(uTTC / 1.20);
      var tTTC = uTTC * item.quantity, tHT = uHT * item.quantity;
      totHT += tHT; totTTC += tTTC;

      var fullTitle = item.product_title || item.title;
      if (item.variant_title && item.variant_title !== 'Default Title') { fullTitle += ' / ' + item.variant_title; }
      var approxLineLen = Math.ceil(70 / 1.8);
      var titleLines = [], words = fullTitle.split(' '), line = '';
      words.forEach(function(w) {
        if ((line + ' ' + w).trim().length > approxLineLen && line !== '') { titleLines.push(line.trim()); line = w; }
        else { line = (line + ' ' + w).trim(); }
      });
      if (line) titleLines.push(line);
      if (item.sku) titleLines.unshift('');
      var rH = Math.max(10, 4 + titleLines.length * 4 + (item.sku ? 4 : 0));

      if (idx % 2 === 1) { fillRect(doc, mL, y, cW, rH, [250,250,250]); }
      hline(doc, mL, y+rH, mL+cW, border);
      tcols.forEach(function(c, i) { if (i < tcols.length-1) vline(doc, c.x+c.w, y, y+rH, border); });

      if (item.sku) { txt(doc, item.sku, mL+14, y+4, {bold:false, size:7, color:mut}); }
      var nameY = y + (item.sku ? 8 : 5);
      txt(doc, item.product_title || item.title, mL+14, nameY, {bold:true, size:8, color:blk});
      if (item.variant_title && item.variant_title !== 'Default Title') {
        txt(doc, item.variant_title, mL+14, nameY+4, {bold:false, size:7, color:mut});
      }
      var midY = y + rH/2 + 1.5;
      txt(doc, String(item.quantity), mL+6, midY, {bold:true, size:8.5, color:blk, align:'center'});
      txt(doc, fmt(uHT), mL+110, midY, {bold:false, size:8, color:blk, align:'right'});
      txt(doc, fmt(tHT), mL+134, midY, {bold:false, size:8, color:blk, align:'right'});
      txt(doc, '20%', mL+143, midY, {bold:false, size:7.5, color:mut, align:'center'});
      txt(doc, fmt(tTTC), W-mR-1, midY, {bold:true, size:8.5, color:bord, align:'right'});
      y += rH;
    });

    var botY = y, botLW = cW * 0.52, botRW = cW * 0.48, botMinH = 45;
    strokeRect(doc, mL, botY, botLW, botMinH, border);
    strokeRect(doc, mL+botLW, botY, botRW, botMinH, border);

    var cy = botY + 4;
    txt(doc, T.conditions, mL+3, cy, {bold:true, size:7, color:blk}); cy += 4;
    doc.setFont('helvetica','normal').setFontSize(6.8).setTextColor(...mut);
    var condL = doc.splitTextToSize(T.cond_text, botLW-6);
    doc.text(condL, mL+3, cy); cy += condL.length * 3.2 + 4;
    txt(doc, T.clause, mL+3, cy, {bold:true, size:7, color:blk}); cy += 4;
    doc.setFont('helvetica','normal').setFontSize(6.8).setTextColor(...mut);
    var clauseL = doc.splitTextToSize(T.clause_text, botLW-6);
    doc.text(clauseL, mL+3, cy); cy += clauseL.length * 3.2;
    if (client.note) {
      cy += 3; hline(doc, mL+3, cy, mL+botLW-3, border); cy += 3;
      txt(doc, T.note_label, mL+3, cy, {bold:true, size:7, color:bord}); cy += 4;
      doc.setFont('helvetica','normal').setFontSize(7).setTextColor(...blk);
      doc.text(doc.splitTextToSize(client.note, botLW-6), mL+3, cy);
    }

    var rx = mL+botLW, rw = botRW, ry = botY;
    var rowHs = [9, 9, 12];
    [{lbl:'Montant HT', val:fmt(totHT), hl:false},
     {lbl:'TVA 20%', val:fmt(totTTC-totHT), hl:false},
     {lbl:'TOTAL TTC', val:fmt(totTTC), hl:true}
    ].forEach(function(row, i) {
      var rh = rowHs[i];
      if (row.hl) { fillRect(doc, rx, ry, rw, rh, bord); doc.setTextColor(...wht); }
      else { hline(doc, rx, ry+rh, rx+rw, border); doc.setTextColor(...blk); }
      doc.setFont('helvetica', row.hl ? 'bold' : 'normal').setFontSize(row.hl ? 9 : 8);
      doc.text(row.lbl, rx+4, ry+rh/2+1.5);
      doc.text('EUR', rx+rw/2, ry+rh/2+1.5, {align:'center'});
      if (row.hl) { doc.setTextColor(...wht); } else { doc.setTextColor(...blk); }
      doc.text(row.val, rx+rw-3, ry+rh/2+1.5, {align:'right'});
      ry += rh;
    });
    hline(doc, rx, ry, rx+rw, border);
    doc.setFont('helvetica','italic').setFontSize(7).setTextColor(...mut);
    doc.text(T.valid_days + ' ' + today(), rx+4, ry+4);

    var fY = 283;
    hline(doc, mL, fY, W-mR, border, 0.3);
    doc.setFont('helvetica','normal').setFontSize(6.5).setTextColor(...mut);
    doc.text('Tel. : +33 (0)5 61 69 84 43 - Fax : +33 (0)5 61 67 86 03 - E-mail : compta@seat-ventilation.com - www.seat-ventilation.com', W/2, fY+4, {align:'center'});
    doc.text('70, impasse Jean Mermoz - Parc Technologique Delta Sud - 09340 Verniolle - France', W/2, fY+8, {align:'center'});
    doc.setFont('helvetica','bold');
    doc.text('SAS AU CAPITAL DE 38 112,25 EUR - R.C.S FOIX 775 736 556 - SIRET 775 736 55600041 - TVA FR 36 775 736 556', W/2, fY+12, {align:'center'});

    doc.save('Devis_SEAT_' + num + '.pdf');
    return num;
  }

  function injectModal() {
    if (document.getElementById('sqoverlay')) return;
    var html =
      '<div id="sqoverlay">' +
      '<div id="sqmodal">' +
      '<button class="sqclose" type="button">&times;</button>' +
      '<div class="sqheader">' +
      '<img src="https://cdn.shopify.com/s/files/1/0692/0074/0660/files/Logo_detoure.png?v=1670432566" alt="SEAT" class="sqlogo" />' +
      '<div><div class="sqtitle">' + T.title + '</div><div class="sqsubtitle">' + T.subtitle + '</div></div>' +
      '</div>' +
      '<div class="sqgrid">' +
      '<div class="sqfield"><label class="sqlabel">' + T.company + '</label><input class="sqinput sqcompany" type="text" placeholder="' + T.ph_company + '" /></div>' +
      '<div class="sqfield"><label class="sqlabel">' + T.name + ' <span class="sqreq">*</span></label><input class="sqinput sqname" type="text" placeholder="' + T.ph_name + '" /></div>' +
      '<div class="sqfield"><label class="sqlabel">' + T.email + ' <span class="sqreq">*</span></label><input class="sqinput sqemail" type="email" placeholder="' + T.ph_email + '" /></div>' +
      '<div class="sqfield"><label class="sqlabel">' + T.phone + '</label><input class="sqinput sqphone" type="tel" placeholder="' + T.ph_phone + '" /></div>' +
      '<div class="sqfield sqfull"><label class="sqlabel">' + T.address + '</label><input class="sqinput sqaddress" type="text" placeholder="' + T.ph_address + '" /></div>' +
      '<div class="sqfield sqfull"><label class="sqlabel">' + T.note + '</label><textarea class="sqinput sqnote" rows="3" placeholder="' + T.ph_note + '"></textarea></div>' +
      '</div>' +
      '<div class="sqerror"></div>' +
      '<button class="sqgenerate" type="button">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>' +
      T.generate + '</button>' +
      '<div class="sqlegal">' + T.legal + '<br/>' + T.confirm + ' <a href="mailto:seatventilationsas@gmail.com">seatventilationsas@gmail.com</a></div>' +
      '</div></div>';

    var div = document.createElement('div');
    div.innerHTML = html;
    document.body.appendChild(div.firstChild);

    var overlay = document.getElementById('sqoverlay');
    var modal   = document.getElementById('sqmodal');

    modal.querySelector('.sqclose').addEventListener('click', function() { overlay.classList.remove('open'); });
    overlay.addEventListener('click', function(e) { if (e.target === overlay) overlay.classList.remove('open'); });

    modal.querySelector('.sqgenerate').addEventListener('click', async function() {
      var errDiv  = modal.querySelector('.sqerror');
      var btnGen  = modal.querySelector('.sqgenerate');
      var name    = modal.querySelector('.sqname').value.trim();
      var email   = modal.querySelector('.sqemail').value.trim();
      var company = modal.querySelector('.sqcompany').value.trim();
      var phone   = modal.querySelector('.sqphone').value.trim();
      var address = modal.querySelector('.sqaddress').value.trim();
      var note    = modal.querySelector('.sqnote').value.trim();

      if (!name || !email) { errDiv.textContent = T.err_fields; errDiv.style.display = 'block'; return; }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { errDiv.textContent = T.err_email; errDiv.style.display = 'block'; return; }
      errDiv.style.display = 'none';

      try {
        var res = await fetch('/cart.js');
        var cart = await res.json();
        if (!cart.items || !cart.items.length) { errDiv.textContent = T.err_cart; errDiv.style.display = 'block'; return; }
        btnGen.disabled = true; btnGen.textContent = T.generating;
        var num = await makePDF({name:name, email:email, company:company, phone:phone, address:address, note:note}, cart);

        /* ── Soumission HubSpot silencieuse ── */
        try {
          var hsPortalId = '8117237';
          var hsFormId = isEN ? '9409f1e8-c730-44a1-a0b6-3d71a0e55a31' : '3dac03ff-4d9e-4374-ae70-aaebf5eafc9a';
          var hsPayload = {
            fields: [
              {name: 'firstname', value: name.split(' ')[0] || name},
        {name: 'lastname', value: name.split(' ').slice(1).join(' ')},
        {name: 'email', value: email},
        {name: 'company', value: company},
        {objectTypeId: '0-2', name: 'name', value: company},
              {name: 'phone', value: phone},
              {name: 'address', value: address},
              {name: 'message', value: note + '\n\nDevis : ' + num}
            ],
            context: (function () { var c = {pageUri: window.location.href, pageName: document.title}; var m = document.cookie.match(/(?:^|; )hubspotutk=([^;]*)/); if (m && !/(?:^|; )__hs_do_not_track=/.test(document.cookie)) c.hutk = m[1]; return c; })()
          };
          fetch('https://api.hsforms.com/submissions/v3/integration/submit/' + hsPortalId + '/' + hsFormId, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(hsPayload)
          });
        } catch(hsErr) { console.log('HubSpot error', hsErr); }

        modal.innerHTML =
          '<div style="text-align:center;padding:20px 10px;">' +
          '<div style="font-size:18px;font-weight:700;color:#520d23;margin-bottom:10px;">' + T.success + '</div>' +
          '<div style="font-size:13px;color:#555;line-height:1.7;margin-bottom:20px;">' + T.success_msg + ' <strong>' + email + '</strong>.</div>' +
          '<button id="sqclosesuccess" style="padding:12px 28px;background:#520d23;color:#fff;border:none;border-radius:3px;cursor:pointer;font-size:14px;font-weight:700;">' + T.close + '</button>' +
          '</div>';
        document.getElementById('sqclosesuccess').addEventListener('click', function() { overlay.classList.remove('open'); });
        
      } catch(err) {
        var e2 = modal.querySelector('.sqerror');
        if (e2) { e2.textContent = T.err_gen; e2.style.display = 'block'; }
        var b2 = modal.querySelector('.sqgenerate');
        if (b2) { b2.disabled = false; b2.textContent = T.generate; }
      }
    });
  }

  document.addEventListener('click', function(e) {
    if (e.target.closest('.seat-btn-open-quote')) {
      var existing = document.getElementById('sqoverlay');
      if (existing) existing.remove();
      injectModal();
      document.getElementById('sqoverlay').classList.add('open');
    }
  });

  injectModal();

})();
